/** Emojis offered in the text editor, in groups (sport first – it is a sports club). */
export const EMOJI_GROUPS: { label: string; list: string[] }[] = [
  {
    label: 'Sport',
    list: [
      '🏊',
      '🚴',
      '🏃',
      '🚵',
      '🏋️',
      '🤸',
      '🧘',
      '🚣',
      '🏄',
      '⛷️',
      '🎿',
      '🧗',
      '🥾',
      '👟',
      '🎽',
      '🌊',
      '⛰️',
      '🏔️',
      '⏱️',
      '💪',
      '🏅',
      '🥇',
      '🥈',
      '🥉',
      '🏆',
      '🏟️',
    ],
  },
  {
    label: 'Leben',
    list: [
      '😀',
      '😂',
      '😊',
      '😎',
      '🤩',
      '🥳',
      '😅',
      '🥵',
      '🥶',
      '🙏',
      '👏',
      '👍',
      '🤝',
      '❤️',
      '💙',
      '🔥',
      '⭐',
      '🎉',
      '🎂',
      '🎁',
      '🎄',
      '🍻',
      '🥂',
      '☕',
      '🍕',
      '🍰',
      '🍝',
      '📸',
    ],
  },
  {
    label: 'Wetter & Orga',
    list: ['🌞', '⛅', '🌧️', '⛈️', '❄️', '🌙', '📍', '🗓️', '⏰', '🚗', '🚆', '🚌', '📣', 'ℹ️', '❓', '⚠️', '✅', '❌'],
  },
];
